(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-accessibility-status.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/use-accessibility-status.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect;
setGlobal('svs.ticketgames.ticketUtility.utils.useAccessibilityStatus', _ref => {
  let _ref$isEInstant = _ref.isEInstant,
    isEInstant = _ref$isEInstant === void 0 ? false : _ref$isEInstant;
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    demoLoadingMsg = _useState2[0],
    setDemoLoadingMsg = _useState2[1];
  useEffect(() => {
    if (!isEInstant) {
      setDemoLoadingMsg('Spelet håller på att laddas');
      let showingDemoBadge = false;
      const handleTag = data => {
        if (data.detail) {
          const _data$detail = data.detail,
            event = _data$detail.event,
            _data$detail$requestR = _data$detail.requestResponse,
            requestResponse = _data$detail$requestR === void 0 ? {} : _data$detail$requestR,
            eventType = _data$detail.eventType,
            name = _data$detail.name;
          if (event === 'createITGBet' && eventType === 'requestResponse' && requestResponse.data) {
            if (requestResponse.data.demo) {
              showingDemoBadge = true;
              setDemoLoadingMsg('Animation för provlott. Spelet startar snart');
            } else {
              setDemoLoadingMsg('');
            }
          } else if (event === 'getItgTicket' && eventType === 'requestResponse') {
            showingDemoBadge = true;
          } else if (event === 'state' && eventType === 'view' && name === 'reveal' && showingDemoBadge) {
            setDemoLoadingMsg('');
            showingDemoBadge = false;
          }
        }
      };
      const handlePreBet = data => {
        if (data.detail) {
          const demo = data.detail.demo;
          if (!demo) {
            setDemoLoadingMsg('');
          }
        }
      };
      addEventListener('TAG', handleTag);
      addEventListener('HANDLE_PREBET', handlePreBet);
    }
  }, []);
  return {
    demoLoadingMsg
  };
});

 })(window);